//#################### Path :: app/scripts/content.js//####################

var markerIcon;
function popUp(nameOfPage, cb) {
    var modal = $('.modalContent');
    modal.html('');
    modal.load(nameOfPage + '.php');
    $('#myModal').foundation('reveal','open');
    $('#myModal').addClass('modal_' + nameOfPage);

    if(cb){
        $('#myModal').on('close.fndtn.reveal',cb);
        
    }
}

function findPlace(text, cb) {

    destTypeaheadResults = [];


    var myPositionCoords = [];
    myPositionCoords[0] = currentPositionMarker.getPosition().lat;
    myPositionCoords[1] = currentPositionMarker.getPosition().lng;
    var myPosition = {title: 'Ma position', position: myPositionCoords};

    var places = platform.getPlacesService();
    places.search({
        'at': map.getCenter().lat + ',' + map.getCenter().lng,
        'q': text,
        'Accept-Language': 'fr-ca'
    }, function (response) {
        //handle response
        destTypeaheadResults = [];
        response.results.items.forEach(function (item) {

            destTypeaheadResults.push(item);
        });
        if ($('#startSearchBox').typeahead('val').toLowerCase() !== 'ma position' && $('#destSearchBox').val().toLowerCase() !== 'ma position' && navigatorLocation) {
            destTypeaheadResults.unshift(myPosition);
        }
        cb(destTypeaheadResults);

    }, function (error) {
        console.log(error);
    });
}

function getWorkZones() {
    workZonesGroup = new H.map.Group();
    var colPlacemarkers;
    $.ajax({
        url: '/placemark.php',
        data: {"url-action": "get"},
        type: "POST"
    }).success(function (response) {
        colPlacemarkers = JSON.parse(response);
    }).done(function () {
     markerIcon = new H.map.Icon(colPlacemarkers[0].placemark_type_icon);
     for (var i = 0; i < colPlacemarkers.length; i++) {
        displayWorkZone(colPlacemarkers[i]);
    }
    //getLinksToAvoid(colPlacemarkers);
    workZonesProvider.getRootGroup().addObject(workZonesGroup);
    workZonesLayer = new H.map.layer.ObjectLayer(workZonesProvider);
    map.addLayer(workZonesLayer);

});
}

function displayWorkZone(workZone) {
    if (workZone.coordinates.length > 1) {
        var strip = new H.geo.Strip();
        for (var i = 0; i < workZone.coordinates.length; i++) {
            strip.pushLatLngAlt(workZone.coordinates[i].latitude, workZone.coordinates[i].longitude, 0);
        }

        var polyline = new H.map.Polyline(
            strip,
            {style: {strokeColor: '#E87600', lineWidth: 5, lineDash: [5,10]}, data: {placemarker: workZone}});
        polyline.opacity = 0.7; 
        //Handler pour le click
        polyline.addEventListener('tap', function (evt) {
            evt.stopPropagation()
            var placemarker = evt.target.getData().placemarker;
            displayBubbleForMarker(placemarker);
        })
        workZonesGroup.addObject(polyline);



    var markerCoords = {lat: workZone.coordinates[0].latitude, lng: workZone.coordinates[0].longitude};
    var marker = new H.map.Marker(markerCoords, {icon: markerIcon, data: {placemarker: workZone}});
    //Handler pour le click
    marker.addEventListener('tap', function (evt) {
        evt.stopPropagation();
        var placemarker = evt.target.getData().placemarker;
        displayBubbleForMarker(placemarker);
    }, true);
    workZonesGroup.addObject(marker);
    }
}

function displayBubbleForMarker(workZone) {

    var markerCoords = {lat: workZone.coordinates[0].latitude, lng: workZone.coordinates[0].longitude};

    var bubbleContent = '<div>' + workZone.placemark_name + '<img src="' + workZone.placemark_type_icon + '"/><br><button id="' + workZone.placemark + '" class="button round tiny infoBubbleBtn">infos</button></div>';
//              
openBubble(markerCoords, bubbleContent);

document.getElementById(workZone.placemark).addEventListener('click',function(evt){
    var idToFind = evt.target.id;
    workZonesGroup.forEach(function(item){
        if(item.getData().placemarker.placemark === idToFind){
            displayPlacemarkerDetails(item.getData().placemarker);
        }
    })
})
}

function displayPlacemarkerDetails(workZone) {

    $('.modalContent').html('<h4 class="small-12 columns center">'+workZone.placemark_name+'</h4>');
    $('.modalContent').append('<div>'+workZone.placemark_description+'</div>');
    $('#myModal').foundation('reveal','open');
}



